import { setToken } from 'core/auth'
import { loadPhiPhase } from 'core/phiFeatureFlags'

import { basicApi } from './requester'

interface UserLoginSSOCredentials {
  code: string
  redirectUri: string
}

export const getSSOAuthenticationFormUrl = (redirectUri: string) =>
  basicApi.get(`/azure/authUrl?redirectUri=${redirectUri}`).then((response) => {
    window.location.replace(response.data)
  })

export const getSSOAuthenticate = async ({ code, redirectUri }: UserLoginSSOCredentials) => {
  const response = await basicApi.get(
    `/azure/authentication?code=${code}&redirectUri=${redirectUri}`,
  )

  setToken(response.data)
  await loadPhiPhase()
  return response
}
